import React, { Component } from "react";
import { logout } from "../../../lib/logout.js";

class Logout extends Component {
  state = {
    loading: false,
  };

  handleLogout = () => {
    this.setState({ loading: true });
    logout()
      .then((responseJSON) => {
        if (
          responseJSON.status ||
          responseJSON.message === "Logout successfull"
        ) {
          window.location.href = "/";
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };

  handleCancel = () => {
    this.setState({ loading: false });
    console.log("Logout canceled");
  };


  render() {
    const { styles } = this.props;
    const { loading } = this.state;
    return (
      <div className={`${styles.logout_modal}`}>
        <div className={styles.logout_icon}>
          <img src="/images/tb_logout_blue.svg" alt="Logout Icon" />
        </div>
        <p className={styles.logout_message}>
          Are you sure you want to Logout?
        </p>
        <div className={styles.modal_button_container}>
          <div className={styles.btn_outline}>
            <button onClick={this.handleLogout} className={loading ? "loading" : ""} disabled={loading}>
              Yes
            </button>
          </div>
          <div className={styles.btn_fill}>
            <button onClick={this.props.onClose}>
              No <img src="images/trightarrow.svg" alt="arrow" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Logout;
